// import constants from './helpers/constants'
import Vue from 'vue'
import router from './router';
import store from "./store";
import i18n from "./i18n";
// import { saveAs } from 'file-saver';

require ('./config/axios_config')
require ('./directives')

// Vue.prototype.$constants = constants
Vue.prototype.$app_name = process.env.MIX_APP_NAME

// layouts
Vue.component('entry-layout', require('./components/layouts/EntryLayout').default);

// prevent log on production
if (process.env.NODE_ENV === 'production') {
    console.log = () => {}
}

store.dispatch('actionInitUser')
  .finally(() => {
      new Vue({
          store,
          i18n,
          router,
          el: '#app',
      });
  })
